import { PagedResponse, RequestResponse } from '@core/services/request/model/request.model';
import {
  MyInvoicesListingApi,
  MyInvoicesListingFilterApi,
  MyInvoicesListingStatusFilterApi,
} from '@core/api/model/my-invoices/invoice-api.model';
import {
  MyInvoicesListingFilter,
  MyInvoicesListingItem,
  MyInvoicesListingStatusFilter,
} from '@core/domain/model/invoices/my-invoices-listing.model';
import { sortDomainToApi } from '@shared/components/table/sort/model/sort.model';
import { pagingDomainToApi } from '@shared/components/paginator/models/paginator-input.model';
import { acJoin } from '@shared/pipes/join/join.pipe';
import { TagTransformer } from '@core/domain/mappers/assistants/tag.transformer';
import { MasterSocietyModel } from '@core/domain/model/master/master-society.model';

export class MyInvoicesListingMapper {
  static invoicesFilterFromDomainToApi(input: MyInvoicesListingFilter): MyInvoicesListingFilterApi {
    const sort = sortDomainToApi(input);
    const paging = pagingDomainToApi(input);
    let stateApi: MyInvoicesListingStatusFilterApi | undefined;
    switch (input.state) {
      case MyInvoicesListingStatusFilter.PAID:
        stateApi = MyInvoicesListingStatusFilterApi.PAGADO;
        break;
      case MyInvoicesListingStatusFilter.PENDING_PAYMENT:
        stateApi = MyInvoicesListingStatusFilterApi.PENDIENTE;
        break;
    }
    return {
      ...sort,
      ...paging,
      filterCodSociedades: input.societies,
      filterCodInstalaciones: input.installations,
      filterNumFactura: input.invoiceNumber,
      filterFechaIniEmision: input.startIssueDate?.toISOString(),
      filterFechaFinEmision: input.endIssueDate?.toISOString(),
      filterEstadoFactura: stateApi,
    };
  }
  static invoicesRequestFromApiToDomain(
    input: RequestResponse<PagedResponse<MyInvoicesListingApi>>,
    ggccSocieties?: MasterSocietyModel[]
  ): RequestResponse<PagedResponse<MyInvoicesListingItem>> {
    return {
      ...input,
      data: {
        ...input.data,
        values: input.data.values.map((value) => MyInvoicesListingMapper.invoiceItemFromApiToDomain(value, ggccSocieties)),
      },
    };
  }

  static invoiceItemFromApiToDomain(input: MyInvoicesListingApi, ggccSocieties?: MasterSocietyModel[]): MyInvoicesListingItem {
    const status = TagTransformer.tagFromInvoice(
      input.estadoFacturaCodigo,
      input.codigoNivelReclamacion,
      input.parado,
      ggccSocieties?.map((value) => value.codigo).includes(input.codigoRazonSocial) ?? false
    );
    return {
      invoiceNumber: input.numeroFactura,
      societyName: input.nombreRazonSocial,
      societyId: input.codigoRazonSocial,
      societyCif: input.cif,
      societyCompleteName: acJoin([input.nombreRazonSocial, input.cif], ' | '),
      installationName: input.nombreInstalacion,
      installationId: input.codigoInstalacion,
      installationCups: input.cups,
      issueDate: input.fechaEmision,
      supplyStartDate: input.fechaInicioSuministro,
      supplyEndDate: input.fechaFinSuministro,
      billingGroup: input.grupoFacturacion,
      type: input.tipo,
      consumption: input.consumo,
      amount: input.importe,
      invoiceStateDescription: status?.description,
      invoiceStateCode: input.estadoFacturaCodigo,
      invoiceStateTag: status?.tag,
      invoiceDocumentId: input.idDCTMFactura,
      installationCupsName: input.nombreInstalacion && input.cups ? (input.nombreInstalacion ?? '') + ' | ' + (input.cups ?? '') : '',
    };
  }
}
